module.exports = __webpack_public_path__ + "/login_ui/img/ni-e68a107db125572b9fa210b908ccf874.svg";